var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"list":_vm.detailList}}),_vm._v(" "),(_vm.gooodsDetail)?_c('goodsproduct',{attrs:{"gooodsDetail":_vm.gooodsDetail,"goodsType":_vm.type}}):_vm._e(),_vm._v(" "),(_vm.gooodsDetail)?_c('goodsdetailimg',{attrs:{"gooodsDetail":_vm.gooodsDetail,"goodsType":_vm.type}}):_vm._e(),_vm._v(" "),_c('smActivity',{ref:"smAct"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016e4238","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/detail/index.vue
// module id = null
// module chunks = 